// features/journey/journeySlice.js
import { createSlice } from "@reduxjs/toolkit";
import { fetchJourneys } from "./journeyThunk";

const journeySlice = createSlice({
  name: "journey",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearJourneys: (state) => {
      state.data = [];
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJourneys.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchJourneys.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload; // API ka response
      })
      .addCase(fetchJourneys.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch journeys";
      });
  },
});

export const { clearJourneys } = journeySlice.actions;
export default journeySlice.reducer;
